import React, { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import Select from "react-select";
import "./product.css";
import { useSelector } from "react-redux";
import axiosinstances from "../../Helper/useAxios";
import {  toast } from "react-toastify";
import { isSuperAdmin, isUserAdmin, stylesofStype, stylesofStypeNew } from "../../utils/comman/Common";
import CreatableSelect from 'react-select/creatable';
import Pagination from "../../utils/Pagination";


export default function ProductList() {
  const [axiosInstance] = axiosinstances();
  const [statusOption, setStatusOption] = useState([{value: 'SUCCESS', label: 'SUCCESS'},{value: 'ACCEPTED', label: 'ACCEPTED'}, {value:'PENDING',label:'PENDING'}, {value:'INTERNAL_FAILURE',label:'INTERNAL_FAILURE'}, 
  {value:'PROCESSING',label:'PROCESSING'},{value:'HUNG',label:'HUNG'} ,{value:'FAILED',label:'FAILED'},{value:'AUTO_REVERSED',label:'AUTO_REVERSED'},{value:'MANUALLY_REVERSED',label:'MANUALLY_REVERSED'}, {value:'SUCCESS_TO_FAILED',label:'SUCCESS_TO_FAILED'}]);
  const token = JSON.parse(sessionStorage.getItem("token"));
  const requesterId = useSelector((state) => state.selectedretailerReqesterReducer.requesterId);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const date = new Date();
  let unique_id = uuid();
  const intialvalues = {
    header: {
      msgType: "CREATE_PRODUCT_PRICING",
      service: "PRICING",
      channel: "ADMIN",
      requesterId: requesterId,
      requestId: unique_id,
      time: date,
    },
    productTree: {
      serviceCode: "",
      categoryCode: "",
      productCode: "",
    },
    type: "",
    entityType: "",
    slabs: [
      {
        from: "0",
        to: "1",
        type: "PERCENT",
        value: "0",
        maxValue: "1",
        minValue: "0",
      }
    
    ],
    tax: "INCLUSIVE",
    maxTxnValue: "",
    minTxnValue: "",
    maxOrderValue: "",
    allowMaxTxnMultiple: true,
    actionBy: "",
    reason: "Adding new pricing",
    tags: [],
  };
  const [table, setTable] = useState([]) 
  const [searched, setSearched] = useState('')
  const [productDetails, setProductDetails] = useState(intialvalues);
  const [selectedTag, setSelectedTag] = useState([]);
  const [tag, setTag] = useState("");
  const [permissionOption, setPermissionOption] = useState([]);
  const [paginationDetails, setPaginationDetails] = useState({
		currentPage: 1,
		posts: [],
		loading: null,
		postsPerPage: 15
	});
  //console.log('selectedTag', selectedTag)
  const [serviceCode, setServiceCode] = useState([])
  const [categoryCode, setCategoryCode] = useState([])
  const [productCode, setProductCode] = useState([])
  //console.log('table', table)
  //console.log('serviceCode', serviceCode)
  //console.log('categoryCode', categoryCode)
  //console.log('productCode', productCode)
  const fetchproductList = async () => {
    const response = await axiosInstance
      .get(`/api/v1/pricing/product`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        if(res.status === 200){
          setTable(res?.data?.all)
        }
      })
      .catch((err) => {
        //console.log(err);
       
      });
    if (response) {
      const result = response.data.orders;
      if (result) {
      }

      return response.data;
    }
    return false;
  };
  useEffect(() => {
    if (id !== undefined) {
      fetchproductList()
    }
  }, [id]);
  useEffect(() => {
    if (id !== undefined) {
      setProductDetails({
        ...productDetails,
        actionBy: id,
      });
    }
  }, [id]);

  useEffect(() => {
    if (Array.isArray(table) && table.length > 0) {
      let serCode = []
      let procode = []
      let catCode = []
     table.map((val, index)=>{

      let newserCode = val.productTree?.serviceCode !== undefined ? {value: val?.productTree?.serviceCode, label: val?.productTree?.serviceCode}   : ''
        let newproCode = val.productTree?.productCode !== undefined ? {value: val?.productTree?.productCode, label: val?.productTree?.productCode}  : ''
        let newCatCode = val.productTree?.categoryCode !== undefined ? {value: val?.productTree?.categoryCode, label: val?.productTree?.categoryCode} : ''
        serCode.push(newserCode)
        procode.push(newproCode)
        catCode.push(newCatCode)

     })
     let filteredSerList = [...new Set(serCode.map(JSON.stringify))].map(JSON.parse)
     let filteredCatList = [...new Set(catCode.map(JSON.stringify))].map(JSON.parse)
     let filteredProList = [...new Set(procode.map(JSON.stringify))].map(JSON.parse)
     setServiceCode(filteredSerList)
     setCategoryCode(filteredCatList)
     setProductCode(filteredProList)
    }
  }, [table]);

  const indexOfLastPost = paginationDetails.currentPage * paginationDetails.postsPerPage;

	const indexOfFirstPost = indexOfLastPost - paginationDetails.postsPerPage;
  const currentPosts = table !== undefined && table !== ''  &&  table.filter((val) => {
		if (searched === '') {
			return val
		} else if(searched !== '' && !val?.id.toLowerCase().includes(searched.toLowerCase()) && val?.type.toLowerCase().includes(searched.toLowerCase())){
      return val
     } else if(searched !== '' && !val?.id.toLowerCase().includes(searched.toLowerCase()) && !val?.type.toLowerCase().includes(searched.toLowerCase()) && val.tags.includes(searched.toLowerCase())){
      return val
     } else if (val.id !== undefined && val?.id.toLowerCase().includes(searched.toLowerCase())) {
			return val
		}
	}).slice(indexOfFirstPost, indexOfLastPost);
  const addSlab = (index) =>{
    setProductDetails({
      ...productDetails,
        slabs:[...productDetails.slabs,{
        from: +productDetails?.slabs[index]?.to + 1,
        to: +productDetails?.slabs[index]?.to + 2,
        type: "PERCENT",
        value: "0",
        maxValue: "1",
        minValue: "0",
      }]
    });
  }
  const removeSlab = (index) =>{
    let tempSlab = [...productDetails.slabs]
    var filtered = tempSlab !== undefined && tempSlab.filter(function (value, ind) {
      return ind !== index;
    });
    const changedData = filtered.map((values, i)=>{
      if(i == 0){
        return values
      } else{
        values.minValue = filtered[i-1].maxValue + 1
        return values
      }

    })
    setProductDetails({
      ...productDetails,
      slabs:[...changedData]
    });
   
  }
  const productHandle = (e,index) => {
    let { name, value } = e.target;
    if (
      name === "serviceCode" ||
      name == "categoryCode" ||
      name == "productCode"
    ) {
      value = value.toUpperCase()
      setProductDetails({
        ...productDetails,
        productTree: {
          ...productDetails.productTree,
          [name]: value,
        },
      });
    } else if (
      name === "from" ||
      name == "to" ||
      name == "value" ||
      name == "maxValue" ||
      name == "minValue"
    ) {
      let tempSlab = [...productDetails.slabs]
      tempSlab[index][name]= value
      setProductDetails({
        ...productDetails,
        slabs:[...tempSlab]
      });
    } else {
      if (value === "true") {
        value = true;
      } else if (value === "false") {
        value = false;
      }
      setProductDetails({
        ...productDetails,
        [name]: value,
      });
    }
  };

  const salesDetails = () => {
    const slots = 'price'
   
    return productDetails?.slabs !== undefined && Array.isArray(productDetails?.slabs) && productDetails.slabs.map((val, ind,self) => {

      return (
        <div class="pricelist">
          <div class="pricbtn" id={`prcslb${ind + 3}${slots}`}>
          {ind !== 4 && ind + 1 == self.length && <button type="button" class="add-slab" data-toggle="tooltip" title="Add Slab" onClick={()=>addSlab(ind)} ></button> }
      { self.length !== 1 && self.length == ind +1 && self.length < 5 ? <button type="button" class="remove-slab" data-toggle="tooltip" title="Remove Slab"
      onClick={()=>removeSlab(ind)}
       ></button> : ind == 0 && self.length == 1 ? '' :
       <button type="button" class="remove-slab-one" data-toggle="tooltip" title="Remove Slab" onClick={()=>removeSlab(ind)}
       ></button> 
      }
            <button
              type="button"
              class="collapsed"
              data-bs-toggle="collapse"
              data-bs-target={`#slab${ind + 3}${slots}`}
              aria-expanded="true"
              aria-controls={`slab${ind + 3}${slots}`}
            >
              {`Price Slab ${ind + 1}`}
            </button>
          </div>

          <div
            id={`slab${ind + 3}${slots}`}
            class="collapse"
            aria-labelledby={`prcslb${ind + 3}${slots}`}
            data-bs-parent="#pricesale"
          >
            <div class="slabox">
              <div class="row">
                <div class="col-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="prinput">
                          <div class="row">
                            <div class="col-6 col-sm-6">
                              <div class="input-group">
                                <span class="input-group-text">Min Slab</span>
                                <input
                                  type="number"
                                  min={0}
                                  
                                  class="form-control form-control-sm"
                                  placeholder="Enter"
                                  onChange={(e)=>productHandle(e,ind)}
                                  name="from"
                                  onWheel={ event => event.currentTarget.blur() }
                                  // onKeyDown={e => {e.stopPropagation(); e.preventDefault()}}
                                  value={productDetails.slabs[ind].from}
                                />
                              </div>
                            </div>

                            <div class="col-6 col-sm-6">
                              <div class="input-group">
                                <span class="input-group-text">Max Slab</span>
                                <input
                                min={0}
                                  type="number"
                                  class="form-control form-control-sm"
                                  placeholder="Enter"
                                  onChange={(e)=>productHandle(e,ind)}
                                  name="to"
                                  value={productDetails.slabs[ind].to}
                                  onWheel={ event => event.currentTarget.blur() }
                                />
                              </div>
                            </div>

                            <div class="col-12 col-sm-6 text-sm-end">
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="col-12">
                  <div class="slbhd">
                    <h5>Bank</h5>
                    <div class="slctype">
                      <p>Percent</p>
                      <div class="form-check form-switch">
                        <input
                         
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          id=""
                          value={productDetails?.slabs[ind]?.type}
                          onChange={(e)=>percentageHandle(e,ind)}
                        />
                      </div>
                      <p>Fixed</p>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="prinput">
                    <div class="row">
                      {
                      productDetails?.slabs[ind]?.type ==='PERCENT' && 
                        <>
                      <div class="col-6 col-sm-4">
                        <div class="input-group">
                          <span class="input-group-text">Percent</span>
                          <input
                            type="number"
                            min={0}
                            class="form-control form-control-sm"
                            placeholder="Enter"
                            // disabled={isFixedSelected}
                            onWheel={ event => event.currentTarget.blur() }
                            onChange={(e)=>productHandle(e,ind)}
                            name="value"
                            value={productDetails.slabs[ind].value}
                          />
                        </div>
                      </div>

                      <div class="col-6 col-sm-4">
                        <div class="input-group">
                          <span class="input-group-text">Min</span>
                          <input
                            type="number"
                            min={0}
                            class="form-control form-control-sm"
                            placeholder="Enter"
                            onChange={(e)=>productHandle(e,ind)}
                            name="minValue"
                            onWheel={ event => event.currentTarget.blur() }
                            value={productDetails.slabs[ind].minValue}
                          />
                        </div>
                      </div>

                      <div class="col-6 col-sm-4">
                        <div class="input-group">
                          <span class="input-group-text">Max</span>
                          <input
                            type="number"
                            min={0}
                            class="form-control form-control-sm"
                            placeholder="Enter"
                            onChange={(e)=>productHandle(e,ind)}
                            name="maxValue"
                            onWheel={ event => event.currentTarget.blur() }
                            value={productDetails.slabs[ind].maxValue}
                          />
                        </div>
                      </div>
                      </>
                      }
                    {
                      productDetails.slabs[ind].type === "ABSOLUTE" &&
                     <div class="col-6 col-sm-4">
                        <div class="input-group">
                          <span class="input-group-text">Fixed</span>
                          <input
                            type="number"
                            min={0}
                            class="form-control form-control-sm"
                            placeholder="Enter"
                            onChange={(e)=>productHandle(e,ind)}
                            name="value"
                            onWheel={ event => event.currentTarget.blur() }
                            value={productDetails.slabs[ind].value}
                          />
                        </div>
                      </div> }
                    </div>
                  </div>
                </div>

                
              </div>
            </div>
          </div>
        </div>
      );
    });
  };
 
  const changeHandler = (select) => {
    setSelectedTag(select);
  };
  const tagHandler = (e) => {
    setTag(e.target.value);
  };
  const percentageHandle = (e, index) => {
    let {value, name} = e.target
    value = value =='ABSOLUTE' ? "PERCENT": 'ABSOLUTE'
    let tempSlab = [...productDetails.slabs]
    tempSlab[index]['type']= value
      if(value == 'ABSOLUTE'){
        tempSlab[index]['minValue']= null
        tempSlab[index]['maxValue']= null
      } else if(value == 'PERCENT'){
        tempSlab[index]['minValue']= 0
        tempSlab[index]['maxValue']= 1 
      }
    setProductDetails({
      ...productDetails,
      slabs:[...tempSlab]
    });
  };
  const getFinalTag = () => {
    if (selectedTag.length !== 0) {
      const allTags = selectedTag.map((val) => val.value);
      return allTags;
    } else {
      return [];
    }
  };

  useEffect(() => {
    const finalvalues = getFinalTag();
    setProductDetails({
      ...productDetails,
      tags: finalvalues,
    });
  }, [selectedTag]);

  const addTagHandler = () => {
    setSelectedTag([...selectedTag, { value: tag, label: tag }]);
    setTag("");
  };
  const createProductPrice = async () => {
    const url = `/api/v1/pricing/product/create`;
    const response = await axiosInstance
      .post(
        url,
        {
          ...productDetails,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        //console.log("user created res-->", res);
        if (res.status == 200) {
          setProductDetails(intialvalues)
          setSelectedTag([])
          setTag('')
          fetchproductList()
        }
      })
      .catch((err) => {
        //console.log(err);
      });
    return false;
  };

  const onsubmit = () =>{
  const temp = [...productDetails.slabs]
  if(temp.length === 1){
    if(+temp[0]?.from >= +temp[0]?.to){
      toast.error(`min slab is greater than max slab of slab 0`);
    } else if(temp[0]?.type == 'PERCENT' && +temp[0].minValue > +temp[0].maxValue){
      toast.error(`min value is greater than max value of slab 0`);
    }  else{
      createProductPrice(); 
    }
  }else{
   for (var i = 0; i < temp.length; i++) {
    if(i !== 0){
      if(+temp[i].from <= +temp[i - 1].to){
        toast.error("Check you slab again");
        break;         
      } else if(+temp[i].minValue > +temp[i].maxValue){
        toast.error(`min values is greater than max values of slab ${i+1}`);
        break;  
      } else if(+temp[i].from > +temp[i - 1].to && temp.length-1 == i){
        createProductPrice();
      } 
  }
}
}
}
//console.log(productDetails)
const checkDisable = () =>{
  let disabled = true
  if(productDetails.productTree.categoryCode !== '' && productDetails.productTree.productCode !== '' && productDetails.productTree.serviceCode !== '' && productDetails.type !== '' && productDetails.entityType !== '' && productDetails.maxTxnValue !== '' && productDetails.minTxnValue !== '' ){
    disabled = false
  }
  return disabled
}
const handleChangeServiceCode = (
  newValue,
  actionMeta
) => {
  console.group('Value Changed');
  //console.log(newValue.value);
  let values = newValue?.value.toUpperCase()
  setProductDetails({
    ...productDetails,
    productTree: {
      ...productDetails.productTree,
      ['serviceCode']: values,
    },
  });
  //console.log(`action: ${actionMeta.action}`);
  console.groupEnd();
};
const handleChangeCategoryCode = (
  newValue,
  actionMeta
) => {
  console.group('Value Changed');
  //console.log(newValue.value);
  let values = newValue?.value.toUpperCase()
  setProductDetails({
    ...productDetails,
    productTree: {
      ...productDetails.productTree,
      ['categoryCode']: values,
    },
  });
  //console.log(`action: ${actionMeta.action}`);
  console.groupEnd();
};
const handleChangProductCode = (
  newValue,
  actionMeta
) => {
  console.group('Value Changed');

let values = newValue?.value.toUpperCase()
  setProductDetails({
  ...productDetails,
  productTree: {
    ...productDetails.productTree,
    ['productCode']: values,
  },
});
  //console.log(`action: ${actionMeta.action}`);
  console.groupEnd();
};
const handleInputChange = (inputValue, actionMeta) => {
  console.group('Input Changed');
  //console.log(inputValue);
  //console.log(`action: ${actionMeta.action}`);
  console.groupEnd();
};
const handleEdit = (data) =>{
  //console.log('data', data)

  setProductDetails((pre)=>{
    return({
      ...pre,
      type:data?.type,
      entityType:data?.entityType,
      maxOrderValue:data?.maxOrderValue,
      maxTxnValue:data?.maxTxnValue,
      minTxnValue:data?.minTxnValue,
      slabs:[...data.slabs]

  })
  })
}
  return (
    
    isSuperAdmin(id) &&  isUserAdmin(id) &&
    <div class="midcontant">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-7">
            <div class="head-pr">
              <div class="row mt-4">
                <div class="col-12 col-md-12 col-lg-3 col-xl-4">
                  <h3>Product Listing</h3>
                </div>
                <div class="col-12 col-md-6 col-lg-5 col-xl-4">
                  <div class="search-pr">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search product..."
                      onChange={(e)=>setSearched(e.target.value)}
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-3 col-xl-3">
                  <div class="action">
                    {/* <button
                      type="button"
                      class="delete btn waves-effect waves-light"
                      data-toggle="modal"
                      data-target="#deleteproduct"
                      style={{backgroundColor:'#fff', border:'2px solid red'}}
                    ></button> */}
                    {/* <button
                      type="button"
                      class="price btn"
                      data-toggle="tooltip"
                      title="Set Price"
                      style={{backgroundColor:'#fff', border:'2px solid #007aff'}}
                    ></button> */}
                    {/* <button
                      type="button"
                      class="add btn"
                      data-toggle="tooltip"
                      title="Add Product"
                      
                    ></button> */}
                  </div>
                </div>
                {/* <div class="col-12 col-md-6 col-lg-1 col-xl-1">
                  <div class="filterbtn dropdown">
                    <button
                      type="button"
                      class="filter btn"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{backgroundColor:'#fff', border:'2px solid #007aff'}}
                    ></button>

                    <form>
                      <div class="dropdown-menu dropdown-menu-right">
                        <div class="filters">
                          <label for="select-state">Type:</label>
                          <select
                            data-placeholder="..."
                            multiple
                            class="chosen-select"
                            tabindex="8"
                          >
                            <option value="1">Money Transfer</option>
                            <option value="2">Recharge</option>
                            <option value="3">Bill Payment</option>
                            <option value="4">Wallet Loading</option>
                            <option value="5">Load Money</option>
                            <option value="6">Aadhar Pay</option>
                            <option value="7">Gift Cards</option>
                          </select>
                        </div>

                        <div class="filters">
                          <label for="select-state">From:</label>
                          <input type="date" name="" placeholder="DD/MM/YYYY" />
                        </div>
                        <div class="filters">
                          <label for="select-state">To:</label>
                          <input type="date" name="" placeholder="DD/MM/YYYY" />
                        </div>
                        <div class="filters">
                          <button type="reset" class="clear" id="btnClear">
                            Clear
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div> */}
              </div>
            </div>

            <div class="productlist">
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <th>
                        {/* <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="chh1"
                            
                          />
                          <label
                            class="custom-control-label"
                            for="chh1"
                          ></label>
                        </div> */}
                      </th>
                      <th>Product ID</th>
                      <th>Type</th>
                      <th>Min txn value</th>
                      <th>Max txn value</th>
                      <th>Added Date</th>
                    </tr>
                    {
                      currentPosts !== undefined && currentPosts.length > 0 && 
                      currentPosts.map((data,index)=>{
                        return <tr key={index}>
                        <td>
                        <i class="bi bi-pencil-fill" onClick={()=>handleEdit(data)} ></i>
                          {/* <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id={`check${index}`}
                              checked={false}
                            />
                            <label
                              class="custom-control-label"
                              for={`check${index}`}
                            ></label>
                          </div> */}
                        </td>
                        <td>
                          {data?.id !== undefined && data?.id !== null && data?.id }
                        </td>
                        <td>{data?.type !== undefined && data?.type !== null && data?.type }</td>
                        <td>₹ {data?.minTxnValue !== undefined && data?.minTxnValue !== null && data?.minTxnValue }</td>
                        <td>₹ {data?.maxTxnValue !== undefined && data?.maxTxnValue !== null && data?.maxTxnValue }</td>
                        <td>{data.createdOn.split('T')[0].replace(/-/g,'/')
                                            } </td>
                      </tr>
                      })
                    }
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="totalno">Showing 1 to {currentPosts?.length} </div>
                </div>

                <div class="col-12 col-md-6">
                  {/* <nav class="pager">
                    <ul class="pagination pagination-sm">
                      <li class="page-item disabled">
                        <span class="page-link">Prev</span>
                      </li>
                      <li class="page-item active">
                        <span class="page-link">1</span>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#">
                          2
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#">
                          3
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#">
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav> */}
                  {
                    table.length > 15  && searched == "" &&
                     <Pagination
                     className="pagination-bar"
                     currentPage={paginationDetails.currentPage}
                     totalCount={table.length}
                     pageSize={paginationDetails.postsPerPage}
                     onPageChange={page => setPaginationDetails((prev)=> {return({...prev, currentPage:page})})}
                     />
                    }
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-5 mt-4">
            <div class="card">
              <div class="addnewproduct">
                <div class="cardheader">
                  <button
                    class="close btn"
                    data-toggle="tooltip"
                    title=""
                    data-original-title="Close"
                  ></button>
                  <h3>Add New Product</h3>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 mb-2">
                    <div className="selct-search-drop" >
                    <label  >Service Code</label>
                    <CreatableSelect
                      name = 'serviceCode'
                       isClearable
                       components={{
                        IndicatorsContainer: () => null,
                        IndicatorSeparator: () => null,
                      }}
                       onChange={handleChangeServiceCode}
                      onInputChange={handleInputChange}
                         options={serviceCode}
                         styles={stylesofStypeNew}
                        />
                    
                    </div>
                    {/* <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="serviceCode"
                        placeholder="Enter Service Code"
                        name="serviceCode"
                        onChange={productHandle}
                        value={productDetails?.productTree?.serviceCode}
                      />
                      <label for="serviceCode">Service Code</label>
                    </div> */}
                  </div>
                  <div class="col-12 col-sm-6 mb-2">
                    <div className="selct-search-drop" >
                    <label  >Category Code</label>
                    <CreatableSelect
                    
                       isClearable
                       components={{
                        IndicatorsContainer: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      name='categoryCode'
                       onChange={handleChangeCategoryCode}
                      onInputChange={handleInputChange}
                         options={categoryCode}
                         styles={stylesofStypeNew}
                        
                        />
                    
                    </div>
                    
                  </div>
                  {/* <div class="col-12 col-sm-6 mb-2">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="categoryCode"
                        placeholder="Enter Category Code"
                        name="categoryCode"
                        onChange={productHandle}
                        value={productDetails?.productTree?.categoryCode}
                      />
                      <label for="categoryCode">Category Code</label>
                    </div>
                  </div> */}
                  <div class="col-12 col-sm-6 mb-2">
                    <div className="selct-search-drop" >
                    <label  >Product Code</label>
                    <CreatableSelect
                       name="productCode"
                       isClearable
                       components={{
                        IndicatorsContainer: () => null,
                        IndicatorSeparator: () => null,
                      }}
                       onChange={handleChangProductCode}
                      onInputChange={handleInputChange}
                         options={productCode}
                         styles={stylesofStypeNew}
                        />
                    
                    </div>
                    
                  </div>
                  {/* <div class="col-12 col-sm-4 mb-2">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="pcode"
                        placeholder="Enter Product Code"
                        name="productCode"
                        onChange={productHandle}
                        value={productDetails?.productTree?.productCode}
                      />
                      <label for="pcode">Product Code</label>
                    </div>
                  </div> */}
                  <div class="col-12 col-sm-6 mb-2">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="type"
                        onChange={productHandle}
                        name="type"
                        value={productDetails.type}
                      >
                        <option value="">Select</option>
                        <option value="COMMISSION">COMMISSION</option>
                        <option value="SURCHARGE">SURCHARGE</option>
                        <option value="CASHBACK">CASHBACK</option>
                      </select>
                      <label for="type">Type</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 mb-2">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="entityType"
                        onChange={productHandle}
                        name="entityType"
                        value={productDetails.entityType}
                      >
                        <option value="">Select</option>
                        <option value="CUSTOMER">CUSTOMER</option>
                        <option value="SUPPLIER">SUPPLIER</option>
                        <option value="RETAILER">RETAILER</option>

                        <option value="DISTRIBUTOR">DISTRIBUTOR</option>
                        <option value="PARTNER">PARTNER</option>
                        <option value="CORPORATE">CORPORATE</option>

                        <option value="WHITELABEL">WHITELABEL</option>
                        <option value="HO">HO</option>
                      </select>
                      <label for="entityType">Entity Type</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 mb-2">
                    <div class="form-floating">
                      <input
                        type="number"
                        onWheel={ event => event.currentTarget.blur() }
                        class="form-control"
                        id="minTxnValue"
                        placeholder="Enter Min Txn Value"
                        name="minTxnValue"
                        onChange={productHandle}
                        value={productDetails?.minTxnValue}
                      />
                      <label for="minTxnValue">Min Txn Value</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 mb-2">
                    <div class="form-floating">
                      <input
                        type="number"
                        class="form-control"
                        id="maxTxnValue"
                        placeholder="Enter Max Txn Value"
                        name="maxTxnValue"
                        onChange={productHandle}
                        onWheel={ event => event.currentTarget.blur() }
                        value={productDetails?.maxTxnValue}
                      />
                      <label for="maxTxnValue">Max Txn Value</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 mb-2">
                    <div class="form-floating">
                      <input
                        type="number"
                        class="form-control"
                        id="maxOrderValue"
                        placeholder="Enter Max Order Value"
                        name="maxOrderValue"
                        onChange={productHandle}
                        onWheel={ event => event.currentTarget.blur() }
                        value={productDetails?.maxOrderValue}
                      />
                      <label for="maxOrderValue">Max Order Value</label>
                    </div>
                  </div>

                  {/* <div class="col-12 col-sm-6 mb-2">
                    <div class="form-floating">
                      <select
                        class="form-select"
                        id="allowMaxTxnMultiple"
                        onChange={productHandle}
                        name="allowMaxTxnMultiple"
                        value={productDetails?.allowMaxTxnMultiple}
                      >
                        <option value="">Select</option>
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </select>
                      <label for="allowMaxTxnMultiple">
                        Allow Max Txn Multiple
                      </label>
                    </div>
                  </div> */}

                  {/* <div class="col-12">
                    <div class="file-upload">
                      <label class="control-label">Upload Product Logo</label>

                      <div class="dropzone-wrapper">
                        <div class="dropzone-desc">
                          <i class="camera"></i>
                          <h6>
                            Drag & Drop or <span>Browes</span> product logo
                          </h6>
                          <p>File: jpg, png, gif and max size 2 MB</p>
                        </div>
                        <input type="file" name="img_logo" class="dropzone" />
                      </div>

                      {/* <div class="preview-zone invisible">
										<div class="box">
											<div class="progress" style="height: 6px;">
												<div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
											</div>										
											<div class="box-body"></div>
											<button type="button" class="remove-preview">Remove</button>
										</div>
									</div> */}
                  {/* </div>
                  </div> */}
                  {selectedTag.length > 0 && (
                    <div className="col-12 col-md-12 mb-2">
                      <div class="form-floating">
                        <div className="formselect">
                          <label>Selected Tag</label>
                          <Select
                            className="basic-multi-select"
                            styles={stylesofStype}
                            closeMenuOnSelect={false}
                            components={{
                              IndicatorsContainer: () => null,
                              IndicatorSeparator: () => null,
                            }}
                            isMulti
                            options={permissionOption}
                            onChange={changeHandler}
                            value={selectedTag}
                            placeholder=" select multiple option"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div class="col-12 col-sm-8 mb-2">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="tag"
                        placeholder="Enter new tag"
                        value={tag}
                        onChange={tagHandler}
                      />
                      <label for="tag">Enter New Tag</label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-3">
                    <button
                      type="button"
                      className="btn dbbtn"
                      onClick={addTagHandler}
                    >
                      Add Tag
                    </button>
                  </div>
                  <div
                    class="prconfig"
                    id="pricebox2"
                     // style={{ display: "none" }}
                  >
                <div class="pricbox" id="pricesale">
                 {salesDetails()}
                </div>
               </div>
                  
             </div>
             <div class="col-12 col-sm-7 mt-4">
                   
                   <button
                     type="button"
                     className="btn dbbtn"
                     onClick={onsubmit}
                     disabled={checkDisable()}
                   >
                     Submit
                   </button>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
